import Vue from 'vue';

import { assign, get } from 'lodash';
import * as api from 'api/api-persons';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saved: null,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saved: null,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  PersonMeasurement: state => id => state[id],
};

const actions = {
  GetPersonMeasurement({ commit }, params) {
    const type = params.type;
    const id = params.id;
    const measurementID = params.measurementID;

    commit(types.FETCH_PERSON_MEASUREMENT_START, { id });
    api.getPersonMeasurement(
      type,
      id,
      measurementID,
      (response) => {
        commit(types.RECEIVE_PERSON_MEASUREMENT, { id, response });
      },
      (description, status, error) => {
        commit(types.FETCH_PERSON_MEASUREMENT_ERROR, { id, error });
      },
    );
  },
  AddPersonMeasurement({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const payload = params.payload;

      commit(types.ADD_PERSON_MEASUREMENT_START, { id });
      console.log('ADD_PERSON_MEASUREMENT_START payload', params);
      api.addPersonMeasurement(
        type,
        id,
        payload,
        (response) => {
          commit(types.ADD_PERSON_MEASUREMENT_SUCCESSFUL, { id, response });
          dispatch('AddMeasurementToPersonMeasurements', { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.ADD_PERSON_MEASUREMENT_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  EditPersonMeasurement({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const measurementID = params.measurementID;
      const payload = params.payload;

      commit(types.EDIT_PERSON_MEASUREMENT_START, { id });
      console.log('EDIT_PERSON_MEASUREMENT_START payload', params);
      api.editPersonMeasurement(
        type,
        id,
        measurementID,
        payload,
        (response) => {
          commit(types.EDIT_PERSON_MEASUREMENT_SUCCESSFUL, { id, response });
          dispatch('EditMeasurementToPersonMeasurements', { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.EDIT_PERSON_MEASUREMENT_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  DeletePersonMeasurement({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const measurementID = params.measurementID;

      commit(types.DELETE_PERSON_MEASUREMENT_START, { id });
      console.log('DELETE_PERSON_MEASUREMENT_START payload', params);
      api.deletePersonMeasurement(
        type,
        id,
        measurementID,
        () => {
          commit(types.DELETE_PERSON_MEASUREMENT_SUCCESSFUL, { id });
          dispatch('DeleteMeasurementFromPersonMeasurements', { id, measurementID });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.DELETE_PERSON_MEASUREMENT_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearPersonMeasurementStore({ commit }, { id }) {
    commit(types.CLEAR_PERSON_MEASUREMENT_STORE, { id });
  },
};

const mutations = {
  [types.FETCH_PERSON_MEASUREMENT_START](state, { id }) {
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_PERSON_MEASUREMENT_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.RECEIVE_PERSON_MEASUREMENT](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },
  [types.CLEAR_PERSON_MEASUREMENT_STORE](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },
  [types.ADD_PERSON_MEASUREMENT_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.ADD_PERSON_MEASUREMENT_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.ADD_PERSON_MEASUREMENT_SUCCESSFUL](state, { id, response }) {
    const list = get(response, 'data.list', false);
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: list, meta: response.meta }));
  },
  [types.EDIT_PERSON_MEASUREMENT_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.EDIT_PERSON_MEASUREMENT_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.EDIT_PERSON_MEASUREMENT_SUCCESSFUL](state, { id, response }) {
    const list = get(response, 'data.list', false);
    if (list) Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: list, meta: response.meta }));
  },
  [types.DELETE_PERSON_MEASUREMENT_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.DELETE_PERSON_MEASUREMENT_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.DELETE_PERSON_MEASUREMENT_SUCCESSFUL](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/persons/entities/person-measurement.js